module.exports = __webpack_public_path__ + "static/media/close.ce29618f.svg";